import angular from 'angular';

module.exports = angular.module('common.directives.icon', [])
.directive('icon', function() {
  return {
    restrict: 'E',
    scope: true,
    template: '<svg class="icon"><use xlink:href="{{href}}"></use></svg>',
    replace: true,
    link: function link(scope, element, attrs) {
      element.addClass(attrs.name);
      scope.href = '#' + attrs.name;
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/icon.js
 **/